import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Project } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type UpdateProjectInput = {
  name: string;
};

export const useUpdateProject = (
  projectId: string,
  options: Omit<UseMutationOptions<Project, UnprocessableEntityError, UpdateProjectInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Project, UnprocessableEntityError, UpdateProjectInput, unknown>({
    mutationFn: async (input: UpdateProjectInput): Promise<Project> => {
      const response = await api.patch<Project>(`/projects/${projectId}`, underscore(input));
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects"],
      });
    },
    ...options
  });
};
